<script>
import { api } from "@/store/modules/templates";

export default {
  props: {
    templateId: {
      type: String,
      required: true
    }
  },
  computed: {
    currentTemplate() {
      return this.$store.state[api.namespace][api.state.loadedAudits][
        this.templateId
      ];
    }
  }
};
</script>
